import { render, staticRenderFns } from "./InvoiceApiCard.vue?vue&type=template&id=10cc0e80&scoped=true"
import script from "./InvoiceApiCard.vue?vue&type=script&lang=js"
export * from "./InvoiceApiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc0e80",
  null
  
)

export default component.exports